import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IAsignaturasStatus {
	deletedAsignatura: boolean;
	dirtyAsignaturas: boolean;
	asignaturaKey: string;
	objetivoKey?: string;
	indicadorKey?: string;
}

const initialState: IAsignaturasStatus[] = [];

const asignaturasStatusSlice = createSlice({
	name: 'asignaturasStatus',
	initialState,
	reducers: {
		addOrUpdateAsignatura: (state, action: PayloadAction<IAsignaturasStatus>) => {
			const index = state.findIndex(
				(asignatura) =>
					asignatura.asignaturaKey === action.payload.asignaturaKey &&
					asignatura?.objetivoKey === action.payload?.objetivoKey &&
					asignatura?.indicadorKey === action.payload?.indicadorKey
			);
			if (index !== -1) {
				// Si la asignatura existe, actualiza su estado
				// eslint-disable-next-line no-param-reassign
				state[index] = action.payload;
			} else {
				// Si la asignatura no existe, la agrega al estado
				state.push(action.payload);
			}
		},
		removeAsignatura: (
			state,
			action: PayloadAction<{ asignaturaKey: string; objetivoKey?: string; indicadorKey?: string }>
		) => {
			const index = state.findIndex(
				(asignatura) =>
					asignatura.asignaturaKey === action.payload.asignaturaKey &&
					asignatura?.objetivoKey === action.payload?.objetivoKey &&
					asignatura?.indicadorKey === action.payload?.indicadorKey
			);
			if (index !== -1) {
				state.splice(index, 1);
			}
		},
		resetAsignaturaStatus: () => {
			return [];
		}
	}
});

export const { addOrUpdateAsignatura, removeAsignatura, resetAsignaturaStatus } = asignaturasStatusSlice.actions;

export default asignaturasStatusSlice.reducer;
